const Persistence = require('utils/persistence');
const AuthPersistence = require('services/auth-management/persistence');

module.exports = () => {

    Persistence.initialize();
    AuthPersistence.migrateAuthPersistence();
};
